// ─── L'invito al bot dei soci, dalla scheda del socio ────────────────────────
//
// 🗣️ 24/09/2026, dal mockup approvato (`mockup/invito-bot-scheda-socio-mockup.html`):
// la segreteria manda al socio il link del bot su WhatsApp.
//
// 🔄 **Dal 25/09/2026 (voce 28) il link è UNO SOLO, uguale per tutti** —
// 🗣️ *«il link di invito Telegram è un link univoco, non personalizzato»*. Qui
// c'era un codice per socio, che scadeva e si ritirava.
//
// 🔒 **Il link non apre niente da solo.** Il bot riconosce il socio dal numero
// condiviso col bottone REGISTRATI, che è il numero dell'account Telegram
// verificato da Telegram: un contatto inoltrato si rifiuta, e un numero scritto
// a mano non si legge. Quel numero deve stare su una sola scheda, attiva.
import { z } from 'zod';
/**
 * Il codice che sta dopo `?start=` negli inviti della segreteria di PRIMA
 * della voce 28. ⏳ Resta finché il bot di prima è in servizio: le rotte
 * `/entry-invites/*` del ponte lo leggono ancora.
 */
export const codiceInvitoSchema = z.string().regex(/^s[A-Za-z0-9_-]{15,40}$/);
/** Il nome del bot su Telegram, senza `@`: le regole di BotFather. */
export const nomeDelBotSchema = z.string().regex(/^[A-Za-z][A-Za-z0-9_]{3,31}$/);
/** Quello che la scheda del socio disegna nel riquadro «Bot dei soci». */
export const invitoAlBotSchema = z.object({
    /** Si è registrato nel bot: lo dice il bot quando lo ammette. */
    inBot: z.boolean(),
    joinedAt: z.iso.datetime().nullable(),
    /** Il telefono della scheda in forma internazionale, o `null`: senza, il bot non lo riconosce. */
    phoneE164: z.string().nullable(),
    /**
     * Il nome del bot come l'ha dichiarato il bot stesso all'avvio, o `null` se
     * non si è ancora presentato: senza, il link non si può comporre.
     */
    botUsername: z.string().nullable(),
    /** Il link del bot, lo stesso per tutti: `null` finché il bot non si presenta. */
    link: z.string().nullable(),
});
// ── Il ponte: quello che il bot chiede ───────────────────────────────────────
/** Il bot si presenta: il gestionale impara come si chiama, per comporre il link. */
export const presentazioneDelBotSchema = z.object({ username: nomeDelBotSchema });
// ⏳ Da qui in giù: il codice della segreteria di prima della voce 28. Lo usa
// solo il bot di prima, e si toglie quando il bot nuovo è in servizio.
/**
 * Com'è un invito quando il socio tocca il link. Il bot non riceve né il nome
 * né il telefono del socio: gli basta sapere se vale, per mostrare la schermata.
 */
export const invitoDelPonteSchema = z.object({
    status: z.enum(['valido', 'scaduto', 'usato', 'ritirato']),
});
export const riscattoInvitoSchema = z.object({ phone: z.string().min(3).max(40) });
/**
 * L'esito del riscatto.
 * ⚖️ `numero_diverso` NON consuma l'invito: il link resta buono per il socio
 * giusto, che magari l'ha girato per sbaglio.
 */
export const esitoRiscattoSchema = z.object({
    outcome: z.enum(['fatto', 'rifiutato']),
    reason: z.enum(['numero_diverso', 'scaduto', 'usato', 'ritirato', 'non_attivo']).nullable(),
    memberId: z.string().nullable(),
    displayName: z.string().nullable(),
    /** Il nome da solo, per il benvenuto del bot. ⇒ `identitaSchema.firstName`. */
    firstName: z.string().nullable(),
    /** Il soprannome, se la segreteria l'ha già scritto nella scheda. */
    nickname: z.string().nullable(),
});
/** Il link del bot, lo stesso per tutti i soci. */
export function linkDelBot(botUsername) {
    return `https://t.me/${botUsername}`;
}
//# sourceMappingURL=invito-bot.js.map